import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Card, CardBody, Button, ButtonGroup } from "@heroui/react";
import { Icon } from "@iconify/react";

export const MedicalQuestionsForm: React.FC = () => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const questions = [
		{
			name: "medicalQuestionnaire.psychiatricTreatment",
			label: "האם אתה נמצא או היית בטיפול פסיכיאטרי?",
			icon: "lucide:brain",
		},
		{
			name: "medicalQuestionnaire.addictionHistory",
			label: "האם יש לך היסטוריה של התמכרות?",
			icon: "lucide:pill",
		},
		{
			name: "medicalQuestionnaire.highBloodSugar",
			label: "האם יש לך רמות סוכר גבוהות בדם?",
			icon: "lucide:droplet",
		},
		{
			name: "medicalQuestionnaire.highBloodPressure",
			label: "האם יש לך לחץ דם גבוה?",
			icon: "lucide:activity",
		},
		{
			name: "medicalQuestionnaire.hasHeartIssues",
			label: "האם יש לך בעיות לב?",
			icon: "lucide:heart",
		},
		{
			name: "medicalQuestionnaire.hasWeaponLicense",
			label: "האם יש לך רישיון נשק?",
			icon: "lucide:shield",
		},
		{
			name: "medicalQuestionnaire.hasTransporters",
			label: "האם יש לך משנעים מורשים?",
			icon: "lucide:truck",
		},
	];

	return (
		<div className="space-y-6">
			<div className="flex items-center gap-3 mb-4">
				<div className="bg-secondary-100 p-2 rounded-full">
					<Icon icon="lucide:stethoscope" className="h-6 w-6 text-secondary" />
				</div>
				<div>
					<h2 className="text-xl font-semibold">שאלון רפואי</h2>
					<p className="text-default-500 text-sm">ענה על השאלות הבאות בכן או לא</p>
				</div>
			</div>

			<Card>
				<CardBody className="p-0">
					<div className="divide-y divide-default-200">
						{questions.map((question, index) => {
							const fieldName = question.name.split(".")[1];
							// todo
							const hasError = !!(errors.medicalQuestionnaire as any)?.[fieldName as any];
							// const currentValue = watchedValues[index];

							return (
								<div
									key={index}
									className={`flex flex-col sm:flex-row sm:items-center justify-between p-4 ${
										hasError ? "bg-danger-50" : ""
									}`}
								>
									<div className="flex items-center gap-3 mb-3 sm:mb-0">
										<div className="bg-content2 p-2 rounded-full">
											<Icon icon={question.icon} className="h-5 w-5 text-default-600" />
										</div>
										<span className="font-medium">{question.label}</span>
									</div>

									<div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
										<Controller
											name={question.name}
											control={control}
											render={({ field }) => (
												<ButtonGroup role="group" aria-label={question.label}>
													<Button
														aria-pressed={field.value === false}
														color={field.value === false ? "danger" : "default"}
														variant={field.value === false ? "solid" : "bordered"}
														onPress={() => field.onChange(false)}
														className="min-w-[80px]"
														startContent={
															<Icon icon="lucide:x" className="h-4 w-4" />
														}
													>
														לא
													</Button>
													<Button
														aria-pressed={field.value === true}
														color={field.value === true ? "success" : "default"}
														variant={field.value === true ? "solid" : "bordered"}
														onPress={() => field.onChange(true)}
														className="min-w-[80px]"
														startContent={
															<Icon icon="lucide:check" className="h-4 w-4" />
														}
													>
														כן
													</Button>
												</ButtonGroup>
											)}
										/>

										{hasError && (
											<div className="text-danger text-sm">יש לבחור תשובה</div>
										)}
									</div>
								</div>
							);
						})}
					</div>
				</CardBody>
			</Card>

			<div className="p-4 bg-warning-50 border border-warning-200 rounded-medium">
				<div className="flex items-start gap-3">
					<Icon
						icon="lucide:alert-triangle"
						className="h-5 w-5 text-warning mt-0.5 flex-shrink-0"
					/>
					<div>
						<h3 className="font-medium text-warning-700 mb-1">שים לב</h3>
						<p className="text-sm text-warning-700">
							המידע הרפואי שתספק חשוב לצורך הערכת הבקשה. אנא וודא שהמידע מדויק ומלא. מידע
							שגוי או חסר עלול לעכב את הטיפול בבקשה או להוביל לדחייתה.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
